// =============================================================================
// SIREPPAR - Búsqueda de texto tolerante
// =============================================================================
// Fuente única para todos los buscadores de la app. Los nombres de partido
// tienen acentos, mayúsculas inconsistentes y siglas con puntos ("MO.VE.GA"),
// así que un `includes()` sobre el texto crudo falla justo cuando más se lo
// necesita: escribir "maiten" no encontraba "EL MAITÉN".

/** Minúsculas y sin acentos: "EL MAITÉN" → "el maiten". */
export function normalizarTexto(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}


/**
 * ¿El texto satisface la búsqueda?
 *
 * Se exige que TODAS las palabras escritas aparezcan en algún lado del texto,
 * sin importar el orden ni que sean contiguas. Así "victoria madryn" encuentra
 * "Unidos y Organizados para la Victoria de Puerto Madryn", que es lo que uno
 * espera al tipear dos pedazos sueltos del nombre que recuerda.
 *
 * Cada palabra puede ser parcial ("vict" ya matchea), porque se busca por
 * inclusión y no por palabra completa.
 */
export function coincideBusqueda(busqueda: string, texto: string): boolean {
  const palabras = normalizarTexto(busqueda).split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return true;
  const objetivo = normalizarTexto(texto);
  return palabras.every(p => objetivo.includes(p));
}
